<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="handleClose"
      width="80%"
      height="800px"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>{{OpStatus == "Add"?'新增轮播图': (OpStatus == "Modify"? '修改轮播图':'查看轮播图')}}</span>
      </template>
      <template #default>
        <div class="single-content-wrapper">
          <el-row class="btn-row">
            <div class="option">
              <el-button v-show="IsShowConfirm" @click="handleConfirm">
                <span>提交</span>
              </el-button>
              <el-button @click="handleCancel">
                <span>关闭</span>
              </el-button>
            </div>
          </el-row>
          <!-- 表达区域-->
          <div class="switch-display border-all">
            <!-- 表单区域-->
            <div class="switch-content">
              <el-form :model="SelectData" :rules="rules" size="small">
                <div class="formtable">
                  <el-row :gutter="20" class="row-bg">
                    <el-col :span="24">
                      <div class="grid-content bg-purple">
                        <el-form-item label="优先级:" prop="startDate">
                          <el-input-number
                            v-model="SelectData.number"
                            class="mx-4"
                            :min="0"
                            size="mini"
                            controls-position="right"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <div class="grid-content bg-purple">
                        <el-form-item label="类型" prop="endDate">
                          <el-select
                            v-model="SelectData.type"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="item in typeList"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="24" v-show="SelectData.type == 1">
                      <div class="grid-content bg-purple">
                        <el-form-item label="url:" prop="status">
                          <el-input
                            v-model="SelectData.url"
                            placeholder="请输入url"
                          />
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="24" v-show="SelectData.type == 2">
                      <div class="grid-content bg-purple">
                        <el-form-item label="文本内容：">
                          <MyCkdeitor
                            @sendContnet="getContent"
                            :content="SelectData.details"
                          ></MyCkdeitor>
                        </el-form-item>
                      </div>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label=" ">
                        <!-- 图片上传 strat-->
                        <el-upload
                          ref="updateImage"
                          drag
                          action="#"
                          multiple
                          :limit="1"
                          :auto-upload="false"
                          :show-file-list="true"
                          :file-list="fileList"
                          :accept="acceptName"
                          list-type="resource"
                          :on-change="changeUploadImg"
                          :on-remove="handleRemove"
                        >
                          <i class="el-icon-upload"></i>
                          <div class="el-upload__text">
                            将文件拖到此处，或<em>点击上传</em>
                          </div>
                          <template v-slot:tip>
                            <div class="el-upload__tip">
                              <span>只能上传jpg/png图片</span>
                              <span class="pictureWarn"
                                >轮播图片建议大小为宽335像素/高160像素</span
                              >
                            </div>
                          </template>
                        </el-upload>
                        <!-- 图片上传 end-->
                      </el-form-item>
                    </el-col>
                    <!-- <el-col>
                      <el-button @click="handleCancel">取 消</el-button>
                      <el-button type="primary" @click="updateImage"
                        >确定上传</el-button
                      >
                    </el-col> -->
                  </el-row>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import {
  SelectSlideshowById,
  ModifySlideshow,
  AddSlideshow,
  SelectSlideshowByNumber,
} from "@api/ApiSlideshow";
import MyCkdeitor from "../RichText/MyCkdeitor.vue";
import { ossUpload, ossPreview } from "@/util/ossClient.js";

export default {
  name: "SlideshowEdit",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
    GUID: {
      type: String,
      default: "",
    },
  },
  components: {
    MyCkdeitor,
  },
  data() {
    return {
      SelectData: {
        type: 1,
        number: "",
        context: "",
        url: "",
        details: "",
        imageName: "",
        resourceUrl: "",
      },
      IsReadonly: false,
      IsShowConfirm: true,
      IsReadonlyCode: true,
      OpStatus: "Detail",
      typeList: [
        { value: 1, label: "链接" },
        { value: 2, label: "富文本" },
        { value: 0, label: "暂不选择" },
      ],
      fileList: [],
      acceptName: ".jpg,.png,.jpeg", //文件格式
    };
  },

  created() {},
  mounted() {},
  methods: {
    /**
     * type==> Add,Modify,Detail
     */
    loadDataById(id, type) {
      const _this = this;
      _this.IsReadonly = false;
      _this.IsShowConfirm = true;
      _this.OpStatus = type;
      _this.IsReadonlyCode = true;

      if (type == "Add") {
        _this.IsReadonlyCode = false;
        _this.SelectData = {};
        _this.SelectData.type = 1;
        return;
      } else if (type == "Modify") {
        _this.IsReadonlyCode = false;
      } else if (type == "Detail") {
        _this.IsReadonly = true;
        _this.IsShowConfirm = false;
      }

      SelectSlideshowById(id).then(function (data) {
        let resultData = data;
        if (data.type == 1) {
          data.url = data.context;
        } else if (data.type == 2) {
          data.details = data.context;
        }
        _this.SelectData = resultData;
      });
    },
    handleSelect(item) {
      console.log(item);
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    GetNameByDm(vaule) {
      var newArr = arr.filter((item) => item.prop == vaule);
      return newArr[0].label;
    },

    handleClose() {
      this.SelectData = {};
      this.$emit("close-dialog");
      this.$refs.updateImage.clearFiles();
    },
    handleCancel() {
      this.SelectData = {};
      this.$emit("handle-cancel");
      this.$refs.updateImage.clearFiles();
    },
    async handleConfirm() {
      var _this = this;
      let loading = _this.GetLoading("保存中...");
      let checkResout = await this.validate();
      if (!checkResout) {
        loading.close();
        return;
      }

      if (_this.OpStatus == "Add") {
        let context = "";
        if (_this.SelectData.type == 1) {
          context = _this.SelectData.url;
        } else if (_this.SelectData.type) {
          context = _this.SelectData.details;
        }
        let USER_INFO = JSON.parse(localStorage.getItem("USER_INFO"))
        let params = {
          creatorName: USER_INFO.UserName,
          releaseDate: new Date(),
          type: _this.SelectData.type,
          number: _this.SelectData.number,
          compayId: USER_INFO.CompanyId,
          resourceUrl: _this.SelectData.resourceUrl, //存Oss管理器上的文件名
          imageName: _this.SelectData.imageName,
          context: context,
        };
        AddSlideshow(params).then(function () {
          _this.$message.success("新增成功!");
          loading.close();
          _this.$emit("handle-confirm");
        });
      } else if (_this.OpStatus == "Modify") {
        let context = "";
        if (_this.SelectData.type == 1) {
          context = _this.SelectData.url;
        } else if (_this.SelectData.type) {
          context = _this.SelectData.details;
        }
        let params = _this.SelectData;
        params.number = _this.SelectData.number;
        params.type = _this.SelectData.type;
        params.context = context;
        params.resourceUrl = _this.SelectData.resourceUrl;
        params.imageName = _this.SelectData.imageName;

        ModifySlideshow(params).then(function (data) {
          loading.close();
          _this.$message.success("编辑成功!");
          _this.$emit("handle-confirm");
        });
      }
    },
    async validate() {
      if (this.SelectData.number == null || this.SelectData.number == "") {
        this.$message.warning("请输入优先级!");
        return false;
      } else if (this.OpStatus == "Add") {
        let result = await SelectSlideshowByNumber(this.SelectData.number);

        if (result) {
          this.$message.warning(
            `优先级：${this.SelectData.number} 已存在，请重新输入！`
          );
          return false;
        }
      }

      if (!this.SelectData.imageName) {
        this.$message.error("图片是必须的!");
        return false;
      }
      if (this.SelectData.type == 1 && !this.SelectData.url) {
        this.$message.error("URL是必须的!");
        return false;
      }
      if (this.SelectData.type == 2 && !this.SelectData.details) {
        this.$message.error("文本内容是必须的!");
        return false;
      }
      return true;
    },
    //获取富文本编译器内容
    getContent(val) {
      this.SelectData.details = val;
    },
    handleRemove(file, fileList) {
      this.SelectData.resourceUrl = "";
      this.SelectData.imageName = "";
    },
    changeUploadImg(file) {
      let _name = file.name.split(".");
      var filetype = _name[1];
      var lx = "";
      let filetypeList = ["jpg", "png", "jpeg"];
      if (!filetypeList.includes(filetype.toLowerCase())) {
        this.$refs.updateImage.handleRemove(file);
        this.$message.error("上传格式错误");
        return false;
      } else {
        this.updateImage();
      }
    },
    //上传图片
    async updateImage() {
      let that = this;
      let files = that.$refs.updateImage.uploadFiles;
      if (files.length <= 0) {
        that.$message.warning("请先选择图片文件!");
        return;
      }

      files = that.$refs.updateImage.uploadFiles.map((el) => {
        return el.raw;
      });

      files.forEach((item) => {
        var formData = new FormData();
        var File = item;
        File.fileName = files
          .map((el) => {
            return el.name;
          })
          .join("|");
        formData.append("File", item);
        let textArray = File.fileName.split(".");
        let extension = "." + textArray[textArray.length - 1]; // 取后缀名
        let fileName = Date.parse(new Date()) + extension;
        let loading = that.GetLoading("上传中...");
        //上传到Oss
        var _this = this;
        ossUpload(fileName, File, "1")
          .then((result) => {
            _this.SelectData.resourceUrl = fileName;
            _this.SelectData.imageName = File.fileName;
          })
          .then((result) => {
            _this.$message.success("图片上传成功!");
            loading.close();
          })
          .catch((e) => {
            loading.close();
          });
      });
    },
    GetLoading(text) {
      return this.$loading({
        lock: true,
        text: text,
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
  },
};
</script>

<style lang="scss" scoped >
.select-items {
  position: relative;
  display: flex;
}

.select-item {
  height: 50px;
  flex: 33.33%;
  display: flex;
  margin: 0 10px;
}
.item-lab {
  flex: 25%;
  line-height: 50px;
  display: flex;
  position: relative;
}

.item-input {
  flex: 75%;
}

.item-lab > label {
  align-items: flex-end;
  position: absolute;
  right: 5px;
}

.Commit {
  padding: 20px 0;
  text-align: center;
}
::v-deep .el-form-item__label {
  width: 80px;
  padding: 0;
  text-align: left;
}
.btn-row {
  height: 40px;
  line-height: 40px;
  margin-bottom: 5px;
}

.option {
  .el-button {
    min-height: 0;
    background: #1c6de4;
    border-radius: 3px;
    font-size: 12px;
    color: #ffffff;
    padding: 12px 20px;
    border: 0;

    .custom-icon {
      font-size: 18px;
      vertical-align: text-bottom;
    }
  }
}
.single-content-wrapper {
  min-height: 60vh;
  background-color: #fff;
  padding-bottom: 15px;
}
.switch-display {
  position: relative;
}
.border-all {
  border: 1px solid #dcdfe6;
}

.priorityNum {
  text-align: left;
  margin: 10px;
}
.pictureWarn {
  margin-left: 10px;
  color: red;
}
</style>
